import styled from "styled-components";
import { StyledaleProps } from "./MenuItem";

export const StyledMenuItem = styled.li<StyledaleProps>`
    ${(props) => props.additionalStyles}
`;